import { ProductType } from "api-client";
import ConfirmModal from "components/ConfirmModal";
import React from "react";
import useProductActions from "../useProductActions";
import { useTranslation } from "react-i18next";
import { productSearchStore as store } from "../ProductSearchStore";
import { observer } from "mobx-react-lite";

const RemoveConfirmModal = () => {
  const { t } = useTranslation();
  const { removeComponent, removeProduct } = useProductActions();
  const removeState = store.removeItemState;

  if (!removeState?.open) return null;

  const isProduct = removeState.type === ProductType.Product;
  const isDeletable = !!removeState.id;

  const handleClose = () => store.setRemoveItemState(undefined);

  if (isDeletable) {
    return (
      <ConfirmModal
        type="warning"
        title={t(
          `mapping.${
            isProduct ? "removeProductTitle" : "removeComponentTitle"
          }`,
          { name: removeState.name }
        )}
        open
        close={handleClose}
        onConfirm={isProduct ? removeProduct : removeComponent}
        confirmButtonTitle={t("mapping.removeProductBtn", {
          name: t(`mapping.${removeState.type?.toLowerCase()}`),
        })}
        descriptionMesage={t(
          `mapping.${isProduct ? "removeProductDesc" : "removeComponentDesc"}`
        )}
        containerClassName="!min-w-[600px]"
        buttonClassName="bg-red-600 hover:!bg-red-700"
      />
    );
  }

  return (
    <ConfirmModal
      type="warning"
      title={t("mapping.removeProductForbidenTitle", {
        name: t(`mapping.${removeState.type?.toLowerCase()}`),
      })}
      open
      close={handleClose}
      hideCancel
      onConfirm={handleClose}
      confirmButtonTitle={t("mapping.closeNote")}
      descriptionMesage={t(
        isProduct
          ? "productEditor.cannotDeleteBPMessage"
          : "components.cannotDeleteComponentMsg"
      )}
      containerClassName="!min-w-[500px]"
    />
  );
};

export default observer(RemoveConfirmModal);
